export default {
    init() {
        // JavaScript to be fired on the home page
        let homeSlider = $('.home-slider__slides');
        if (homeSlider.length) {
            homeSlider.slick({
                autoplay: true,
                fade: true,
                speed: 600,
                autoplaySpeed: 6000,
                infinite: true,
                cssEase: 'ease-in-out',
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                dots: false,
                arrows: true,
                mobileFirst: true,
                rows: 0,
                nextArrow: `<button type="button" class="slick-next btn--no-decoration"><span class="screen-reader-text">Next</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 11H32" stroke="#1C69E0" stroke-width="4" stroke-linecap="round"/>
                <path d="M24.375 2L33 11.2979L24 21" stroke="#1C69E0" stroke-width="4" stroke-linecap="round"/>
                </svg>                    
                    </button>`,
                prevArrow: `<button type="button" class="slick-prev btn--no-decoration"><span class="screen-reader-text">Previous</span><svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M34 11L4 11" stroke="#C2C2C2" stroke-width="4" stroke-linecap="round"/>
                <path d="M11.625 2L3 11.2979L12 21" stroke="#C2C2C2" stroke-width="4" stroke-linecap="round"/>
                </svg></button>`,
                responsive: [
                    {
                        breakpoint: 769, // min-width
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });

            let homeSlidesNavItems = $('.home-slider-navigation__item');

            if (homeSlidesNavItems) {
                homeSlidesNavItems.on('click', function () {
                    let slideIndex = $(this).data('control');
                    homeSlider.slick('slickGoTo', slideIndex);
                    console.log(slideIndex);
                    homeSlidesNavItems.removeClass('nav-item-active');
                    $(this).addClass('nav-item-active');
                });

                homeSlidesNavItems.first().addClass('nav-item-active');

                homeSlider.on(
                    'afterChange',
                    function (event, slick, currentSlide) {
                        homeSlidesNavItems.removeClass('nav-item-active');
                        homeSlidesNavItems
                            .eq(currentSlide)
                            .addClass('nav-item-active');
                    }
                );
            }
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js